import React, { useState } from 'react';
import { PlusIcon, TrendingUpIcon, MenuIcon } from 'lucide-react';
import { InputParametersPanel } from '../components/InputParametersPanel';
import { RecommendationsPanel } from '../components/RecommendationsPanel';
import { ScenarioModeling } from '../components/ScenarioModeling';
import { ForecastVisualization } from '../components/ForecastVisualization';
import { PlanComparison } from '../components/PlanComparison';
export function PlanningPage() {
  const [activeView, setActiveView] = useState<'single' | 'comparison'>('single');
  const [showInputPanel, setShowInputPanel] = useState(false);
  const [inputParams, setInputParams] = useState({
    revenueTarget: 10000000,
    segmentMix: {
      enterprise: 40,
      midMarket: 35,
      smb: 25
    },
    averageDealSize: {
      enterprise: 150000,
      midMarket: 50000,
      smb: 15000
    },
    conversionRates: {
      sql_to_opportunity: 45,
      opportunity_to_close: 25
    }
  });
  const [scenarios, setScenarios] = useState([{
    id: 1,
    name: 'Baseline Plan',
    revenueTarget: 10000000,
    playMix: [{
      play: 'High-Intent Account Blitz',
      allocation: 35
    }, {
      play: 'PLG Activation',
      allocation: 25
    }, {
      play: 'Executive Nurture',
      allocation: 20
    }, {
      play: 'Inbound Lead Scoring',
      allocation: 20
    }],
    budgetAllocation: 850000,
    headcount: 12,
    timeline: '12 months',
    confidence: 78
  }]);
  return <div className="w-full h-screen flex flex-col bg-gray-50" data-id="element-5554">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-4 lg:px-6 py-3 lg:py-4" data-id="element-5555">
        <div className="flex items-center justify-between" data-id="element-5556">
          <div className="flex items-center gap-2" data-id="element-5557">
            <button onClick={() => setShowInputPanel(!showInputPanel)} className="lg:hidden p-2 hover:bg-gray-100 rounded-lg" data-id="element-5558">
              <MenuIcon className="w-5 h-5" data-id="element-5559" />
            </button>
            <div data-id="element-5560">
              <h1 className="text-lg lg:text-2xl font-bold text-gray-900" data-id="element-5561">
                GTM Plan Assembly & Forecasting
              </h1>
              <p className="text-xs lg:text-sm text-gray-600 mt-1 hidden sm:block" data-id="element-5562">
                Build data-driven GTM plans with AI-powered recommendations
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 lg:gap-3" data-id="element-5563">
            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-green-50 text-green-700 rounded-lg border border-green-200" data-id="element-5564">
              <TrendingUpIcon className="w-4 h-4" data-id="element-5565" />
              <span className="text-sm font-medium hidden lg:inline" data-id="element-5566">
                78% Confidence Score
              </span>
              <span className="text-sm font-medium lg:hidden" data-id="element-5567">78%</span>
            </div>
            <button onClick={() => setActiveView(activeView === 'single' ? 'comparison' : 'single')} className="hidden sm:flex items-center gap-2 px-3 lg:px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium" data-id="element-5568">
              {activeView === 'single' ? 'Compare' : 'Single'}
            </button>
            <button className="flex items-center gap-2 px-3 lg:px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm" data-id="element-5569">
              <PlusIcon className="w-4 h-4" data-id="element-5570" />
              <span className="hidden sm:inline" data-id="element-5571">New Scenario</span>
            </button>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="flex-1 overflow-hidden" data-id="element-5572">
        {activeView === 'single' ? <div className="h-full flex flex-col lg:flex-row" data-id="element-5573">
            {/* Mobile Input Panel Overlay */}
            {showInputPanel && <>
                <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowInputPanel(false)} data-id="element-5574" />
                <div className="lg:hidden fixed left-0 top-0 bottom-0 w-full max-w-sm bg-white z-50 overflow-y-auto" data-id="element-5575">
                  <div className="p-4" data-id="element-5576">
                    <div className="flex items-center justify-between mb-4" data-id="element-5577">
                      <h2 className="text-lg font-semibold" data-id="element-5578">
                        Input Parameters
                      </h2>
                      <button onClick={() => setShowInputPanel(false)} className="p-2 hover:bg-gray-100 rounded-lg" data-id="element-5579">
                        ✕
                      </button>
                    </div>
                    <InputParametersPanel params={inputParams} onChange={setInputParams} data-id="element-5580" />
                  </div>
                </div>
              </>}
            {/* Desktop Left Panel */}
            <div className="hidden lg:block w-96 bg-white border-r border-gray-200 overflow-y-auto" data-id="element-5581">
              <InputParametersPanel params={inputParams} onChange={setInputParams} data-id="element-5582" />
            </div>
            {/* Right Panel - Outputs */}
            <div className="flex-1 overflow-y-auto p-4 lg:p-6 space-y-4 lg:space-y-6" data-id="element-5583">
              <RecommendationsPanel params={inputParams} data-id="element-5584" />
              <ScenarioModeling params={inputParams} data-id="element-5585" />
              <ForecastVisualization scenario={scenarios[0]} data-id="element-5586" />
            </div>
          </div> : <div className="h-full overflow-y-auto p-4 lg:p-6" data-id="element-5587">
            <PlanComparison scenarios={scenarios} data-id="element-5588" />
          </div>}
      </div>
    </div>;
}